<template>
  <el-dialog
    ref="runningplanView"
    title="班次详情"
    :visible.sync="drawer"
    :before-close="handleBeforeClose"
    width="80%"
    v-loading="loading"
    element-loading-text="正在加载中～"
    append-to-body
  >
    <div style="padding: 15px">
      <el-form size="small">
        <div style="display: flex; justify-content: flex-end">
          <el-button
            type="primary"
            size="small"
            @click="handleEdit(info)"
            v-if="!needHide"
            v-has-permi="['transport_runningplan_edit']"
            >编辑</el-button
          >
          <running-plan-edit
            ref="runningplanEdit"
            v-if="runningPlanEditShowDialog"
            @refreshDetailsData="refresh"
          />
        </div>
        <el-form-item label="班次类型：">{{ info.flightType }}</el-form-item>
        <el-form-item label="时间：" v-if="info.adjustTime < 0">
          <div
            >{{ info.otherDate }} {{ info.otherTime }}-{{ info.spanDay ? info.departureDate : '' }}
            {{ info.departureTime }}</div
          >
        </el-form-item>
        <el-form-item label="时间：" v-else>{{ info.time }}</el-form-item>
        <el-form-item label="供应商：">{{ info.merchantName }}</el-form-item>
        <el-form-item label="班次状态：">{{ info.flightStatus }}</el-form-item>
        <el-form-item label="归属线路：">
          <yd-link
            :value="info.lineName"
            :permi="'transport_bound_info'"
            :type="'merchantDetal'"
            :need="true"
            :query="{ id: info.merchantPriceId, merchantName: info.merchantName }"
          />
        </el-form-item>
        <el-form-item label="价格方案：">
          <div style="display: flex">
            <div style="margin-right: 20px">{{ info.priceMethodName }}</div>
            <el-button size="small" type="text" @click="changePrice" v-if="!needHide"
              >修改价格</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="运力信息：">
          <el-row :gutter="20">
            <el-col :span="14">
              <el-table :data="info.capacityInfoVOS" size="mini" border>
                <el-table-column label="出车顺序" align="center" prop="sort" />
                <el-table-column label="状态" align="center" prop="driverStatus" />
                <el-table-column label="司机姓名" align="center" prop="driverName" />
                <el-table-column
                  label="司机电话"
                  align="center"
                  width="120"
                  prop="driverPhoneNum"
                />
                <el-table-column label="车牌号" align="center" prop="carNum">
                  <template slot-scope="{ row }">
                    <yd-link
                      :value="row.carNum"
                      :permi="'vehicle_manage'"
                      :need="true"
                      :type="'vehicleDetail'"
                      :query="{ id: row.carId }"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="车型" align="center" prop="carType" />
                <el-table-column label="操作时间" align="center">
                  <template scope="scope">
                    <div v-if="scope.row.capacityTime">{{ scope.row.capacityTime }}</div>
                    <div v-else>——</div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="4">
              <el-button
                size="small"
                type="text"
                @click="handlemodify"
                v-if="!needHide"
                v-has-permi="['transport_runningplan_adjust']"
              >
                调整运力
              </el-button>
              <div class="tipsBox">
                <img style="width: 20px; height: 20px" src="./static/tips.png" />
                <span>点击调整运力可更换城际司机！</span>
              </div>
              <modify-driver
                v-if="modifyDriverDialog"
                ref="modifyDriver"
                @refreshData="getDetail(flightPlanId)"
              />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="站点信息：">
          <el-table :data="info.stationInfoVOS" size="mini" border style="width: 90%">
            <el-table-column label="序号" align="center" prop="sort" />
            <el-table-column label="类型" type="index" align="center">
              <template slot-scope="scope">
                <div v-if="scope.$index === 0">起点</div>
                <div v-else-if="scope.$index === end">终点</div>
                <div v-else>经过</div>
              </template>
            </el-table-column>
            <el-table-column label="站点名称" align="center" prop="stationName" />
            <el-table-column label="是否开启站点" align="center" prop="isOpen" width="110" />
            <el-table-column label="到达时间" align="center" width="120" prop="arrTime" />
            <el-table-column label="里程数（公里）" align="center" prop="mileage" width="110" />
            <el-table-column label="上下车规则" align="center" prop="rule" width="110" />
            <el-table-column label="起售时间" align="center" prop="startTime" />
            <el-table-column label="停售时间" align="center" prop="endTime" />
            <el-table-column label="接送类型" align="center" prop="pickUpType" />
            <el-table-column label="是否开启接送" align="center" prop="openPickUp" width="110" />
            <el-table-column label="是否发车点" align="center" prop="isShow" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.isShow === 1 ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="接送规则"
              align="center"
              prop="pickUpRule"
              fixed="right"
              width="140"
            >
              <template slot-scope="scope">
                <el-popover placement="right" width="580" trigger="click">
                  <el-table :data="scope.row.transportRule" height="400" border size="small">
                    <el-table-column
                      width="120"
                      prop="serviceArea"
                      align="center"
                      label="服务区域"
                    />
                    <el-table-column
                      width="120"
                      prop="pickUpRule"
                      align="center"
                      label="接送方式"
                    />
                    <el-table-column
                      width="120"
                      prop="priceTypeRule"
                      align="center"
                      label="接送模式"
                    >
                      <template slot-scope="scope">
                        <span v-for="item in transportModeDic" :key="item.value">
                          {{ item.value === scope.row.priceTypeRule ? item.label : '' }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="pickUpTime" align="center" label="接人时间" />
                    <el-table-column prop="recommendStation" align="center" label="推荐站点" />
                  </el-table>
                  <el-button slot="reference" type="text" size="small">{{
                    `已开启 ${scope.row.transportRule.length} 个区域接送`
                  }}</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="例检单：">
          <!-- <el-upload
            :action="filePath"
            :headers="header"
            name="file"
            list-type="picture-card"
            :file-list="fileList"
            :show-file-list="true"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="handleBeforeUpload"
            :on-success="handleUpload"
            :data="{ code: 'custom-flight' }"
          >
            <i class="el-icon-plus"></i>
          </el-upload> -->
          <upload-image
            v-if="drawer"
            :file="fileList"
            :code="'custom-flight'"
            :isMultiple="true"
            :disabled="needHide"
            @uploadSuccess="getCarImgList"
            @remove="getCarImgList"
          />

          <el-button
            type="primary"
            size="small"
            @click="submitFile"
            v-if="!needHide"
            v-has-permi="['transport_runningplan_upload']"
          >
            上传例检单
          </el-button>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="imageUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
    </div>
    <priceView v-if="priceShow" ref="priceview" />
    <el-button
      style="margin: 20px 0 10px 0"
      @click="showLogData"
      :loading="logLoading"
      size="small"
      type="primary"
      >操作日志
      <i class="el-icon-arrow-right" v-if="!showLog"></i>
      <i class="el-icon-arrow-down" v-else></i>
    </el-button>
    <transition name="el-fade-in-linear">
      <operation-log v-show="showLog" :visible="showLog" :flightPlanId="flightPlanId" />
    </transition>
  </el-dialog>
</template>

<script>
  import { details, saveFileimg } from '@/api/transport/bustime'
  import runningPlanEdit from './components/runningplan-edit'
  import modifyDriver from './components/modify-driver'
  import priceView from './components/price-view'
  import OperationLog from '@/components/logInfo/list'
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import UploadImage from '@/components/newUpload/index.vue'
  import { transportModeDic } from '@/views/product/_data.js'

  export default {
    name: 'runningPlanView',
    props: {
      needHide: {
        type: Boolean,
        default: false
      }
    },
    filters: {
      typeFilters(type) {
        let mark = ''
        switch (type) {
          case 1:
            mark = '固定班次'
            break
          case 2:
            mark = '滚动班次'
            break
        }
        return mark
      }
    },
    components: {
      runningPlanEdit,
      modifyDriver,
      priceView,
      OperationLog,
      UploadImage
    },
    data() {
      return {
        transportModeDic,
        priceShow: false,
        drawer: false,
        direction: 'ltr',
        runningPlanEditShowDialog: false,
        modifyDriverDialog: false,
        title: '',
        fileType: ['png', 'jpg', 'jpeg'],
        fileList: [],
        flightPlanId: '',
        imageUrl: '',
        end: 0,
        baseUrl: env.uploadUrl + env.ferryUrl,
        filePath: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        header: { Authorization: 'bearer ' + getToken() },
        info: {
          data: []
        },
        flightId: '',
        dialogVisible: false,
        logLoading: false,
        showLog: false,
        logList: [],
        loading: false
      }
    },
    watch: {
      imageUrl: {
        handler(val) {
          console.log(val)
          if (val) {
            // 首先将值转为数组
            const list = Array.isArray(val) ? val : this.value.split(',')
            // 然后将数组转为对象数组
            this.fileList = list.map((item) => {
              if (typeof item === 'string') {
                if (item.indexOf(this.baseUrl) === -1) {
                  item = { name: this.baseUrl + item, url: this.baseUrl + item }
                } else {
                  item = { name: item, url: item }
                }
              }
              return item
            })
          } else {
            this.fileList = []
            return []
          }
        },
        deep: true,
        immediate: true,
        logList: []
      }
    },
    methods: {
      showLogData() {
        this.showLog = !this.showLog
        // if (this.logList.length > 0) {
        //   return
        // }
        // this.getLogData()
      },
      // async getLogData(){
      //   this.logLoading = true
      //   const {code, data} = await getLog({
      //     bizLinkId: this.flightPlanId,
      //     type: 1
      //   })
      //   this.logLoading = false
      //   if (code === 0) {
      //     this.logList = data
      //   }
      // },
      init(row) {
        this.logList = []
        this.showLog = false
        this.direction = '班次详情'
        this.drawer = true
        this.info = row
        this.flightPlanId = row.id
        this.getDetail(row.id)
      },
      // 修改价格方案
      changePrice() {
        const row = {
          type: 1,
          flightId: this.info.flightId,
          flightPlanId: this.flightPlanId
        }
        this.priceShow = true
        this.$nextTick(() => {
          this.$refs.priceview.init(row)
        })
      },

      handlemodify() {
        this.modifyDriverDialog = true
        this.$nextTick(() => {
          const params = {
            merchantId: this.info.merchantId,
            priceMethodId: this.info.priceMethodId,
            flightPlanId: this.flightPlanId,
            lineId: this.info.lineId
          }
          this.$refs.modifyDriver.init(params)
        })
      },
      handleEdit(row) {
        this.runningPlanEditShowDialog = true
        this.$nextTick(() => {
          this.$refs.runningplanEdit.init(row)
        })
      },
      getDetail(id) {
        this.fileList = []
        this.loading = true
        details(id)
          .then((resp) => {
            this.info = resp.data
            if (this.info.uploadCheckTicket !== null) {
              const imgUrl = this.info.uploadCheckTicket.split(',')
              imgUrl.forEach((i) => {
                const var1 = {
                  url: i
                }
                this.fileList.push(var1)
              })
            }
            this.end = this.info.stationInfoVOS.length - 1
          })
          .finally(() => {
            this.loading = false
          })
      },
      // handleRemove(file, fileList) {
      //   const findex = this.fileList.map((f) => f.name).indexOf(file.name)
      //   if (findex > -1) {
      //     this.fileList.splice(findex, 1)
      //   }
      // },
      // handlePreview(file) {
      //   this.dialogVisible = true
      //   this.imageUrl = file.url
      // },
      getCarImgList(arr) {
        this.fileList = arr
      },
      // handleUpload(response) {
      //   if (response.code !== 0) {
      //     this.$message.error(response.msg)
      //     return
      //   }
      //   this.fileList.push({ url: response.data.url })
      // },
      // handleBeforeUpload(file) {
      //   let isImg = false
      //   if (this.fileType.length) {
      //     let fileExtension = ''
      //     if (file.name.lastIndexOf('.') > -1) {
      //       fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1)
      //     }
      //     isImg = this.fileType.some((type) => {
      //       if (file.type.indexOf(type) > -1) return true
      //       if (fileExtension && fileExtension.indexOf(type) > -1) return true
      //       return false
      //     })
      //   } else {
      //     isImg = file.type.indexOf('image') > -1
      //   }

      //   if (!isImg) {
      //     this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}图片格式文件!`)
      //     return false
      //   }
      // },
      submitFile() {
        if (this.fileList.length === 0) {
          this.$message.warning('请上传例检单')
          return
        }
        const data = {
          flightPlanId: this.flightPlanId,
          url: this.listToString(this.fileList, ',')
        }
        saveFileimg(data).then((resp) => {
          if (resp.code === 0) {
            this.$message.success('保存成功')
            this.getDetail(this.flightPlanId)
            this.fileList = []
          }
        })
      },
      // 对象转成指定字符串分隔
      listToString(list, separator) {
        let strs = ''
        separator = separator || ','
        for (const i in list) {
          strs += list[i].url.replace(this.baseUrl, '') + separator
        }
        return strs !== '' ? strs.substr(0, strs.length - 1) : ''
      },
      refresh() {
        this.getDetail(this.flightPlanId)
      },

      handleBeforeClose(done) {
        this.$emit('refreshDataList')
        this.drawer = false
        done()
      }
    }
  }
</script>

<style scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
</style>
